import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTask from './Task/AddTask'
import EditTask from './Task/EditTask'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview from './Task/TaskOverview'
import EntityPage, { ParentProps } from './EntityPage'
import { MenuItemKey } from '../components/MainMenu'
import { TasksProps } from './Tasks'

export const workflowBaseUrl = '/workflow'

export default function Workflows(props: TasksProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={workflowBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.fileId === undefined ? (
                                <GlobalTaskOverview baseUrl={baseUrl} breadcrumb={MenuItemKey.Workflow} />
                            ) : (
                                <TaskOverview
                                    {...routeProps}
                                    {...props}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTaskOverview-${props.fileId}-`}
                                />
                            )
                        }
                    />
                    <Route path={`${route}/add`}>
                        <AddTask returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTask returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
